/* eslint-disable max-len */

import React from 'react'
import styled from 'styled-components'

const SeeMemberTutorialStyled = styled.div`
  position: absolute;
  left: 55%;
  bottom: 10px;
  z-index: 2;
`

const TutorialContent = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-align: left;
  display: inline-block;
  width: 100%;

  letter-spacing: 1px;

  color: #000000;
`

const SeeMemberTutorial = () => (
  <SeeMemberTutorialStyled>
    <svg width="359" height="100" viewBox="0 0 359 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M85 69L47.6829 83.4891L1.63913e-06 100L85 83.4891V69Z" fill="#D4D4FA" />
      <g filter="url(#filter0_d_2314_5447)">
        <rect x="83" y="8" width="272" height="77" rx="10" fill="#DAD9FF" />
        <rect x="83.5" y="8.5" width="271" height="76" rx="9.5" stroke="#D9D9D9" />
      </g>
      <foreignObject className="node" x="120" y="22" width="200" height="300">
        <TutorialContent>
          Invite members and <br />
          share the goals.
        </TutorialContent>
      </foreignObject>
      <circle cx="88" cy="21" r="20.5" fill="#3B82F6" stroke="#3B82F6" />
      <path
        d="M93.1 24.3086H91.38V27.2686H88.44V24.3086H82.34V22.2086L88.6 12.9886H91.38V21.9686H93.1V24.3086ZM88.44 21.9686V19.5486C88.44 19.2419 88.4467 18.8686 88.46 18.4286C88.4733 17.9886 88.4867 17.5819 88.5 17.2086C88.5267 16.8219 88.5467 16.5686 88.56 16.4486H88.48C88.36 16.7152 88.2267 16.9752 88.08 17.2286C87.9467 17.4819 87.7933 17.7419 87.62 18.0086L85 21.9686H88.44Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_2314_5447"
          x="79"
          y="8"
          width="280"
          height="85"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2314_5447" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2314_5447" result="shape" />
        </filter>
      </defs>
    </svg>
  </SeeMemberTutorialStyled>
)

export default SeeMemberTutorial
